var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data[_vm.data.type])?_c(_vm.components[_vm.data.type],{tag:"component",attrs:{"data":Object.assign(_vm.data[_vm.data.type], { embed: true })}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }